import React, { useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Grid2,
  Skeleton,
  Typography,
  useTheme,
} from "@mui/material";
import { ArrowDownward, ArrowOutward, ArrowUpward } from "@mui/icons-material";
import { IoIosHappy } from "react-icons/io";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useParams } from "react-router-dom";
import {
  useGetChangeKpiQuery,
  useGetClaimsKpiQuery,
} from "store/slices/apis/claimsAndChangeOrderDashboardSlice";
import ClaimsPopup from "./ClaimsPopup";
import ProjectStatusOverviewHead from "../../../components/ProjectStatusOverviewHead";
import { ReactComponent as ArrowIcon } from "assets/PwC_Funct_Icons_ArrowIncrease_Outline_Black_RGB.svg"
import { ReactComponent as ArrowUpIcon } from "assets/PwC_Funct_Icons_ArrowUp_Outline_Black_RGB.svg"
import { ReactComponent as ArrowDownIcon } from "assets/PwC_Funct_Icons_ArrowDown_Outline_Black_RGB.svg"

const ClaimsKPI = () => {
  const theme = useTheme();
  const { projectId } = useParams();
  const { data, isLoading: isClaimLoading } = useGetClaimsKpiQuery({
    projectId,
  });
  const { data: changesKpi, isLoading: isChangeLoading } = useGetChangeKpiQuery(
    { projectId }
  );
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);
  const kpiRaw = data?.data || {};

  const lastUpdated = data?.data?.lastUpdated;

  const isLoading = isChangeLoading || isClaimLoading;
  const kpiData = [
    {
      title: "Total Claims Identified",
      value: kpiRaw?.totalIdentified ?? 0,
      color: "#9ED3CC",
      change: null,
      changeColor: "#377E36",
      status: "Identified",
    },
    {
      title: "Total Submitted",
      value: kpiRaw?.totalSubmitted ?? 0,
      color: "#9ED3CC",
      change: null,
      changeColor: "#377E36",
      status: "Submitted",
    },
    {
      title: "Total Approved",
      value: kpiRaw?.totalApproved ?? 0,
      change: kpiRaw?.approvedGrowth ? `${kpiRaw?.approvedGrowth}%` : null,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Approved",
      isPositive: kpiRaw?.approvedGrowth > 0 ? true : false,
      arrow: kpiRaw?.approvedGrowth > 0 ? "up" : "down",
      absoluteChange: !kpiRaw?.approvedGrowth
        ? "-"
        : kpiRaw?.approvedGrowth === -100
          ? "0%"
          : `${Math.abs(kpiRaw?.approvedGrowth)}%`,
      redColor: "#CE412D",
    },
    {
      title: "Total Rejected",
      value: kpiRaw?.totalRejected ?? 0,
      change: kpiRaw?.rejectedGrowth ? `${kpiRaw?.rejectedGrowth}%` : null,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: "Rejected",
    },
    {
      title: "Total Change Orders",
      value: changesKpi?.data?.totalChangeOrders,
      change: null,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: null,
    },
    {
      title: "Cost of Change Orders",
      value: changesKpi?.data?.totalCostOfChangeOrders,
      change: null,
      color: "#9ED3CC",
      changeColor: "#377E36",
      status: null,
    },
  ];

  return (
    <Box>
      <Grid2 container spacing={5} sx={{ mt: "20px" }}>
        <ProjectStatusOverviewHead
          lastModified={lastUpdated}
          marginBottm={"30px"}
        />
      </Grid2>

      <Grid container spacing={2}>
        {(isLoading ? Array(6).fill({}) : kpiData).map((card, index) => (
          <Grid item xs={12} md={3} key={index}>
            <Card
              sx={{
                boxShadow: "none",
                border: "1px solid #25252517",
                borderRadius: "3px",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center">
                  {isLoading ? (
                    <Skeleton
                      variant="rectangular"
                      width={40}
                      height={40}
                      sx={{ mr: 2 }}
                    />
                  ) : (
                    <Box
                      sx={{ bgcolor: card.color, width: 40, height: 40, mr: 2 }}
                    />
                  )}

                  <Box>
                    <Box display="flex" alignItems="center" gap={1}>
                      {isLoading ? (
                        <>
                          <Skeleton variant="text" width={60} height={24} />
                          <Skeleton variant="text" width={50} height={20} />
                        </>
                      ) : (
                        <>
                          <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            {card.value}
                          </Typography>
                          {card.change && (
                            <Chip
                              label={
                                card.absoluteChange
                                  ? card.absoluteChange
                                  : card.change
                              }
                              size="small"
                              sx={{
                                backgroundColor: "#E6F4EA",
                                color: card?.isPositive
                                  ? card?.changeColor
                                  : card?.redColor,
                                fontWeight: 600,
                                fontSize: "12px",
                              }}
                              icon={
                                card?.absoluteChange !== "0%" &&
                                  // (card?.arrow === "up" ? (
                                  //   <ArrowUpward
                                  //     sx={{
                                  //       fontSize: "12px !important",
                                  //       color: card.isPositive
                                  //         ? `${card.changeColor} !important`
                                  //         : `${card?.redColor} !important`,
                                  //     }}
                                  //   />
                                  // ) : (
                                  //   <ArrowDownward
                                  //     sx={{
                                  //       fontSize: "12px !important",
                                  //       color: card.isPositive
                                  //         ? `${card.changeColor} !important`
                                  //         : `${card.redColor} !important`,
                                  //     }}
                                  //   />
                                  // ))
                                  ( card?.arrow === "up" ? (
                                  <ArrowUpIcon
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      fill: card.isPositive ? card.changeColor : card.redColor,
                                    }}
                                  />
                                ) : (
                                  <ArrowDownIcon
                                    style={{
                                      height: "12px",
                                      width: "12px",
                                      fill: card.isPositive ? card.changeColor : card.redColor,
                                    }}
                                  />
                                ))

                              }
                            />
                          )}
                          <Typography
                            variant="body2"
                            sx={{
                              ml: 1,
                              whiteSpace: "nowrap",
                              color: "#474747",
                              opacity: "0.57",
                            }}
                          >
                            this month
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Typography
                      variant="body2"
                      sx={{ color: "#252525", fontWeight: 500, mt: 0.5 }}
                    >
                      {isLoading ? (
                        <Skeleton width={100} height={20} />
                      ) : (
                        card.title
                      )}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  {isLoading ? (
                    <Skeleton variant="circular" width={37} height={37} />
                  ) : card.status ? (
                    <Avatar
                      sx={{
                        bgcolor: "#fff",
                        width: 37,
                        height: 37,
                        border: "1px solid #d3d3d3",
                      }}
                    >
                      {/* <MdOutlineArrowOutward
                                             style={{
                                               color: "#252525",
                                               fontSize: "20px",
                                               cursor: "pointer",
                                              
                                             }}
                                             onClick={() => {
                                               setPopupData(card);
                                               setOpen(true);
                                             }}
                                           /> */}
                      <ArrowIcon
                        style={{
                          color: "#252525",
                          fontSize: "20px",
                          cursor: "pointer",
                          height: "13px",
                          stroke: "#252525",
                          strokeWidth: "6"
                        }}
                        onClick={() => {
                          setPopupData(card);
                          setOpen(true);
                        }}
                      />
                    </Avatar>
                  ) : null}
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {open && (
        <ClaimsPopup
          title={popupData?.title}
          value={popupData?.value}
          status={popupData?.status}
          onOpen={open}
          onClose={() => setOpen(false)}
        />
      )}
    </Box>
  );
};

export default ClaimsKPI;
